import { Component, OnInit } from "@angular/core";
// import { environment } from "@environment";
import { ConfigService } from "../../../_services/config.service";
import { generateId } from "src/app/_helpers/utility/crypto-utils";
import { DBkeys } from "src/app/_services/user/authentication/dbkeys.service";
import { LocalStoreManagerService } from "src/app/_services/user/authentication/local-store-manager.service";

@Component({
    selector: "wfdss-sso-initiation",
    templateUrl: "./sso-initiation.component.html",
    styleUrls: ["./sso-initiation.component.scss"],
    standalone: false
})
export class SsoInitiationComponent implements OnInit {
  /** TODO: Modify this to make sure it pulls from the local store, either cookies
   * or local storage, and might want to convert into an observable
   * Need to make sure the auth service as it exists currently will work for our purposes
   */
  userLoggedIn: boolean = false;

  constructor(private localStorage: LocalStoreManagerService, private environment: ConfigService) {}

  ngOnInit(): void {
    const state = generateId(6);
    this.localStorage.saveSyncedSessionData(state, DBkeys.SSO_STATE)
    // TODO: Convert to observable once ready
    if (!this.userLoggedIn) {
      location.href = `${this.environment.auth.oauthBaseUrl}/oauth/authorize?client_id=${this.environment.auth.clientId}&redirect_uri=${this.environment.auth.postLoginRedirectUrl}&response_type=code&state=${state}`;
    }
  }
}
